import {useEffect, useRef, forwardRef} from 'react';

import { Link } from 'react-router-dom';
import CustomizedSolution from './CustomizeSolutions';
import DoorToDoor from './DoorToDoor';
import DryCargo from './DryCargo';
import EcomSegment from './EcomSegment';
import HubToHub from './HubToHub';
import TemperatureControl from './TemperatureControl';


const OverlandLogistics = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
  
    return(
        <div>
            <div id='international' className="overland-express-image">
                <img src='/new-image/overland-express.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    Formed in 1989, TCS is the market leader in door-to-door goods transportation business in Pakistan. 
                    This business is particularly suited for your bulk cargo movements to around 200 cities of the country, 
                    with 36–72 hours transit time.
                </p>
                <p>
                    TCS Overland Express is the preferred choice of a large corporate customer-base when it comes to secured, 
                    economical and time-definite transportation of heavy cargo shipments to any part of the country. 
                    Our large customer-base includes: pharmaceutical companies, banking sector, major printing houses, 
                    automobile industries, cellular industry, and more.
                </p>
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="sm:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/overland-logistics/door-to-door"  className='font-bold'>Door-to-Door</Link></li>
                            </div>
                            <div className="flex items-center ">
                                <li><Link to="/overland-logistics/temperature-control"  className='font-bold'>Temperature Controlled</Link></li>
                            </div>
                            {/* <div className="flex items-center ">
                                <li><Link to="/overland-logistics/dry-cargo"  className='font-bold'>Dry Cargo</Link></li>
                            </div> */}
                            <div className="flex items-center ">
                                <li><Link to="/overland-logistics/customized-solutions"  className='font-bold'>Customised Solutions</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            
                            <div className="flex items-center ">
                                <li><Link to="/overland-logistics/hub-to-hub"  className='font-bold'>Hub-to-Hub</Link></li>
                            </div>
                            <div className="flex items-center ">
                                <li><Link to="/overland-logistics/ecom-segment"  className='font-bold'>E-commerce / COD</Link></li>
                            </div>
                           
                        </div>
                            
                    </div>
                </div> 
                
                 
            </div>
            
            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="door-to-door">
                <DoorToDoor/>
            </div>
            <div id="temperature-control">
                <TemperatureControl/>
            </div>
            <div id="dry-cargo">
                <DryCargo/>
            </div>
            <div id="ecom-segment">
                <EcomSegment/>
            </div>
            <div id="customized-solutions">
                <CustomizedSolution/>
            </div>
            <div id="hub-to-hub">
                <HubToHub/>
            </div>
            </div>
            
            

        </div>
    )
};
export default OverlandLogistics;